import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useRef, useState } from 'react';
import { CheckFilledSVG, DownloadSVG, HeadphonesSVG, LinkSVG } from '@sbercloud/uikit-product-icons';
import { ButtonTonal } from '@snack-uikit/button';
import { Tooltip } from '@snack-uikit/tooltip';
import { useCalculatorContext } from '../../../../contexts';
import { parseKeyToDataTest } from '../../../../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ProductListActions(_ref) {
  var disabled = _ref.disabled;
  var _useCalculatorContext = useCalculatorContext(),
    products = _useCalculatorContext.products,
    calculatorType = _useCalculatorContext.calculatorType,
    _useCalculatorContext2 = _useCalculatorContext.actions,
    onShareClick = _useCalculatorContext2.onShareClick,
    onDownloadFileClick = _useCalculatorContext2.onDownloadFileClick,
    onRequestConsultationClick = _useCalculatorContext2.onRequestConsultationClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsCheckedOpen = _useState2[1];
  var timerId = useRef();
  var openChecked = function openChecked() {
    return setIsCheckedOpen(true);
  };
  var closeChecked = function closeChecked() {
    return setIsCheckedOpen(false);
  };
  var handleShareClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.stopPropagation();
            onShareClick === null || onShareClick === void 0 ? void 0 : onShareClick({
              products: products,
              calculatorType: calculatorType
            }).then(function () {
              openChecked();
              clearTimeout(timerId.current);
              timerId.current = setTimeout(closeChecked, 1000);
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleShareClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    return function () {
      closeChecked();
      clearTimeout(timerId.current);
    };
  }, []);
  var handleDownloadFileClick = function handleDownloadFileClick() {
    return onDownloadFileClick === null || onDownloadFileClick === void 0 ? void 0 : onDownloadFileClick({
      products: products,
      calculatorType: calculatorType
    });
  };
  var handleRequestConsultationClick = function handleRequestConsultationClick() {
    return onRequestConsultationClick === null || onRequestConsultationClick === void 0 ? void 0 : onRequestConsultationClick({
      products: products,
      calculatorType: calculatorType
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.footerLinks,
    "data-test-id": parseKeyToDataTest('price', 'summary-footer'),
    children: [onShareClick && /*#__PURE__*/_jsx(Tooltip, {
      tip: isChecked ? /*#__PURE__*/_jsxs("div", {
        className: styles.container,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.icon,
          children: /*#__PURE__*/_jsx(CheckFilledSVG, {})
        }), "Cc\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430"]
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439"
      }),
      hoverDelayOpen: 600,
      open: isChecked || undefined,
      children: /*#__PURE__*/_jsx(ButtonTonal, {
        size: "m",
        icon: /*#__PURE__*/_jsx(LinkSVG, {}),
        appearance: "neutral",
        fullWidth: true,
        onClick: handleShareClick,
        "data-test-id": parseKeyToDataTest('price', 'summary-footer-copy-link'),
        disabled: disabled
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      tip: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0441\u0447\u0435\u0442",
      hoverDelayOpen: 600,
      children: /*#__PURE__*/_jsx(ButtonTonal, {
        size: "m",
        icon: /*#__PURE__*/_jsx(DownloadSVG, {}),
        appearance: "neutral",
        "data-test-id": parseKeyToDataTest('price', 'summary-footer-download'),
        fullWidth: true,
        onClick: handleDownloadFileClick,
        disabled: disabled
      })
    }), onRequestConsultationClick && /*#__PURE__*/_jsx(Tooltip, {
      tip: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E",
      hoverDelayOpen: 600,
      children: /*#__PURE__*/_jsx(ButtonTonal, {
        size: "m",
        icon: /*#__PURE__*/_jsx(HeadphonesSVG, {}),
        appearance: "neutral",
        fullWidth: true,
        onClick: handleRequestConsultationClick,
        "data-test-id": parseKeyToDataTest('price', 'summary-footer-consultation'),
        disabled: disabled
      })
    })]
  });
}